import React, { useEffect, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { fetchSystemNotification, selectSystemNotification } from 'app/slice/systemNotificationSlice';
import { Modal } from 'antd';

const SystemNotification = () => {
    const dispatch = useAppDispatch();
    const { data, success } = useAppSelector(selectSystemNotification);

    useEffect(() => {
        dispatch(fetchSystemNotification());
    }, [dispatch]);

    const showModal = useCallback(() => {
        if (!data) return;

        Modal.warning({
            title: <strong>{data.title}</strong>,
            content: <div dangerouslySetInnerHTML={{ __html: data.content }} />,
            okText: 'OK',
            width: 801,
            centered: true,
        });
    }, [data]);

    useEffect(() => {
        if (success && data && !localStorage.getItem('hasSeenNotification')) {
            showModal();
            localStorage.setItem('hasSeenNotification', 'true');
        }
    }, [success, data, showModal]);

    if (!success || !data) {
        return null;
    }

    return (
        <div className='system-notification-container'>
            <p onClick={showModal}>
                {data.startedAt} — {data.title}
            </p>
        </div>
    );
};

export default SystemNotification;
